import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
  Box,
  Radio,
  Dialog,
  TextField as MuiTextField
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import axios, { Axios } from 'axios';
import { BASE_URL } from '../../../../../utils';
import * as Yup from 'yup';
import { dropdownFetch, formatDate, getCurrentDateTime, getKeyPathValue, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { StockManagementTable } from './StockManagementTable';

const BILL_TABLE_HEADER = [
  {
    header: 'Product',
    accessor: (row) => row?.productData?.main?.name
  },
  {
    header: 'CNT/GRN',
    accessor: (row) => row?.productDetails?.cnt
  },
  {
    header: 'hsn_code',
    accessor: (row) => row?.productDetails?.hsn_code
  },

  {
    header: 'mrp',
    accessor: ''
  },
  {
    header: 'Supplier',
    accessor: (row) => row?.supplierData?.ledger_name
  },

  {
    header: 'bill_qty',
    accessor: ''
  },
  {
    header: 'Packing',
    accessor: (row) => row?.productDetails?.packing
  },
  {
    header: 'batch_no',
    accessor: ''
  },
  {
    header: 'total_qty',
    accessor: ''
  },
  {
    header: 'exp_date',
    accessor: ''
  }
];

export const StockManagement = () => {
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const user = JSON.parse(localStorage.getItem('user'));
  const [selectedRows, setSelectedRows] = useState([]);
  const [serviceDropdown, setServiceDropdown] = useState([]);
  const [hsnInputValues, setHsnInputValues] = useState([]);
  const [batchInputValues, setBatchInputValues] = useState([]);
  const [productInputValues, setProductInputValues] = useState([]);
  const [issLoading, setIssLoading] = useState(false);
  const [locationDropdown, setLocationDropdown] = useState([]);
  const [supplierDropdown, setSupplierDropdown] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLocationCheak, setSelectedLocationCheak] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [selectedSupplierCheak, setSelectedSupplierCheak] = useState(false);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    limit: 10
  });
  const methods = useForm({
    resolver: yupResolver(Yup.object().shape({})),
    defaultValues: {
      effective_date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time'),
      bill: {
        out_sourced: 'No',
        rec_amt_1: 0,
        rec_amt_2: 0,
        tds_amt: 0,
        disc_amt: 0,
        gst_amt: 0,
        net_amt: 0
      }
    },
    mode: 'all'
  });
  const { handleSubmit, reset, setValue, watch } = methods;

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord?.service_items?.filter((item) => item.sample_collected === false));
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
    } else {
      reset();
    }
  }, [selectedRecord]);

  const getLocationDropdownData = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    setLocationDropdown(data);
  }, []);

  const getSupplierDropdownData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setSupplierDropdown(data);
  }, []);

  useEffect(() => {
    getLocationDropdownData();
    getSupplierDropdownData();
  }, [getLocationDropdownData, getSupplierDropdownData]);

  const getServiceData = useCallback(
    async (currentPage, selectedLocation, selectedSupplier) => {
      console.log("bybbh")

      if (selectedLocationCheak && selectedSupplierCheak) {
        setIssLoading(true);
        try {
          const response = await axios.get(
            `${BASE_URL}/stock-master-management/list?page=${currentPage}&locationId=${selectedLocation}&supplierId=${selectedSupplier}`
          );
          const { data: newData, pagination: newPagination } = response.data;
          setServiceDropdown((prevData) => [...prevData, ...newData]);
          setPagination(newPagination);
        } catch (error) {
          console.error('Error fetching service data:', error);
        } finally {
          setIssLoading(false);
        }
      }
    },
    [selectedLocationCheak, selectedSupplierCheak]
  );

  const fetchMoreData = (currentPage, selectedLocation, selectedSupplier) => {

    if (!issLoading) {
      getServiceData(currentPage, selectedLocation, selectedSupplier);
    }
  };

  useEffect(() => {
    fetchMoreData(1, selectedLocation, selectedSupplier);
  }, [selectedLocation, selectedSupplier]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    const updatedData = selectedRows.map((row) => {

      const modifiedInputValues = {
        ...row.productDetails
      };

      return {
        productDetails: modifiedInputValues
      };
    });

    console.log(updatedData);
    if(updatedData.length >0){
    try {
      const response = await axios.put(`${BASE_URL}/stock-master-management/update`, { stockUpdates: updatedData });
      if (response?.data?.success) {
        toast(`Stock Updated Successfully`, { variant: 'success' });
        resetFormState();
      } else {
        toast(`Failed to Updated Stock`, { variant: 'error' });
        resetFormState();
      }
      
    } catch (error) {
      resetFormState();
      toast(`Failed to Updated Stock`, { variant: 'error' });
    };}else{
      toast(`Please Select Something to  Update`, { variant: 'warning' });
    }
    setLoading(false);
  }
  const resetFormState = () => {
    setCurrentAction(null);
    setSelectedRecord(null);
    setSelectedRows([]);
    setServiceDropdown([]);
    setSelectedLocationCheak(false);
    setSelectedSupplierCheak(false);
    setSelectedLocation(null);
    setSelectedSupplier(null);
  };



  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find(
      (selectedRow) =>
        selectedRow._id === row._id &&
        selectedRow.productDetails.hsn_code === row.productDetails.hsn_code &&
        selectedRow.productDetails.batch_no === row.productDetails.batch_no
    );
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    console.log(row, field, "vftcdrrd");
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find(
        (selectedRow) =>
          selectedRow._id === row._id &&
          selectedRow.productDetails.hsn_code === row.productDetails.hsn_code &&
          selectedRow.productDetails.batch_no === row.productDetails.batch_no
      );

      if (existingRow) {
        // If the row exists, filter out the existing row (deselect it)
        return prevSelectedRows.filter(
          (selectedRow) =>
            !(selectedRow._id === row._id &&
              selectedRow.productDetails.hsn_code === row.productDetails.hsn_code &&
              selectedRow.productDetails.batch_no === row.productDetails.batch_no)
        );
      } else {
        // If the row doesn't exist, add it to selectedRows with the specified field set to true
        return [
          ...prevSelectedRows,
          { ...row, [field]: true } // Add row with selected field set to true
        ];
      }
    });
  };

  const handleInputChange = (e, rowId, header) => {
    const { value } = e.target;

    // Update the rows with the new input value
    setServiceDropdown((prevData) =>
      prevData.map((row) =>
        row._id === rowId
          ? {
            ...row,
            productDetails: {
              ...row.productDetails, // Retain the other productDetails properties
              [header]: value // Update the specific field based on header
            }
          }
          : row
      )
    );

    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.map((row) =>
        row._id === rowId
          ? {
            ...row,
            productDetails: {
              ...row.productDetails, // Retain the other productDetails properties
              [header]: value // Update the specific field based on header
            }
          }
          : row
      )
    );
  };

  const handleHsnChange = (e) => {
    const newInput = e.target.value;
    setHsnInputValues(newInput);
  };

  const handleBatchChange = (e) => {
    const newInput = e.target.value;
    setBatchInputValues(newInput);
  };

  const handleProductChange = (e) => {
    const newInput = e.target.value;
    setProductInputValues(newInput);
  };


  const handleLocationChange = (event) => {
    const { value } = event.target;
    console.log(value);
    setServiceDropdown([]);
    setSelectedLocationCheak(true);
    setSelectedLocation(value);
  };

  const handleSupplierChange = (event) => {
    const { value } = event.target;
    console.log(value);
    setServiceDropdown([]);
    setSelectedSupplierCheak(true);
    setSelectedSupplier(value);
  };

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                Stock Management
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>

            <Grid container spacing={2}>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Box
                  sx={{
                    border: '0px solid gray',
                    padding: 2,
                    borderRadius: '8px',
                    width: '100%',
                    boxShadow: '0px 2px 10px #0099ff'
                  }}
                >
                  <Stack spacing={2} direction="row" sx={{ mb: 2 }}>
                    <Stack sx={{ flex: 3 }} spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: '1.4rem' }}>Location</Typography>
                      <SelectTag
                        formControlSX={{ flex: 1 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="location"
                        placeholder="Location"
                        menus={locationDropdown.map((data) => ({
                          ...data,
                          name: data.warehouse_name

                        }))}
                        onChange={handleLocationChange}
                      />
                    </Stack>
                    <Stack sx={{ flex: 3 }} spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: '1.4rem' }}>Supplier</Typography>
                      <SelectTag
                        formControlSX={{ flex: 1 }}
                        disabled={!['new', 'edit'].includes(currentAction)}
                        name="supplier"
                        placeholder="Supplier"
                        menus={supplierDropdown.map((data) => ({
                          ...data,
                          name: data.ledger_name
                        }))}
                        onChange={handleSupplierChange}
                      />
                    </Stack>
                  </Stack>
                  <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 2 }}>
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Product Name</Typography>
                    <MuiTextField
                      sx={{
                        width: '50%',
                        padding: 0,
                        '& .MuiInputBase-root': {
                          fontSize: '1.4rem',
                          fontWeight: 700
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '1.2rem'
                        }
                      }}
                      label="Search By Product Name"
                      variant="outlined"
                      value={productInputValues}
                      onChange={handleProductChange}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Batch No.</Typography>
                    <MuiTextField
                      sx={{
                        width: '50%',
                        padding: 0,
                        '& .MuiInputBase-root': {
                          fontSize: '1.4rem',
                          fontWeight: 700
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '1.2rem'
                        }
                      }}
                      label="Search Batch No."
                      variant="outlined"
                      value={batchInputValues}
                      onChange={handleBatchChange}
                    />
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>HSN Code</Typography>
                    <MuiTextField
                      sx={{
                        width: '50%',
                        padding: 0,
                        '& .MuiInputBase-root': {
                          fontSize: '1.4rem',
                          fontWeight: 700
                        },
                        '& .MuiInputLabel-root': {
                          fontSize: '1.2rem'
                        }
                      }}
                      label="Search By HSN Code"
                      variant="outlined"
                      value={hsnInputValues}
                      onChange={handleHsnChange}
                    />
                  </Stack>
                </Box>

                <StockManagementTable
                  containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', minHeight: '30rem' }}
                  fetchMoreData={fetchMoreData}
                  showOk={true}
                  selectedRows={selectedRows}
                  handleRowSelect={handleRowSelect}
                  isSelected={isSelected}
                  issLoading={issLoading}
                  pagination={pagination}
                  hsnInputValues={hsnInputValues}
                  batchInputValues={batchInputValues}
                  productInputValues={productInputValues}
                  selectedSupplier={selectedSupplier}
                  selectedLocation={selectedLocation}
                  data={currentAction === 'new' ? serviceDropdown : []}
                  columns={BILL_TABLE_HEADER}
                  size="small"
                  showInputField={true}
                  handleInputChange={handleInputChange}
                  inputValues={inputValues}
                  onRowClick={(row) => {
                    setSelectedRecord(row);
                  }}
                />

              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
